import _createClass from "@babel/runtime/helpers/createClass";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
/* eslint jsx-a11y/no-noninteractive-tabindex: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FocusService } from '@pattern-library/utils';
var FocusTrap = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FocusTrap, _Component);
  function FocusTrap(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.handleTopFocus = function (event) {
      var onTopFocus = _this.props.onTopFocus;
      FocusService.focusElement(_this.lastFocusableElement);
      onTopFocus(event);
    };
    _this.handleBottomFocus = function (event) {
      var onBottomFocus = _this.props.onBottomFocus;
      FocusService.focusElement(_this.firstFocusableElement);
      onBottomFocus(event);
    };
    _this.state = {
      focusableElements: []
    };
    return _this;
  }
  var _proto = FocusTrap.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var focusableElements = this.findFocusableElements();
    this.setState({
      focusableElements: focusableElements
    });
  };
  _proto.findFocusableElements = function findFocusableElements() {
    var elements = FocusService.getFocusableElementsIn(this.container);
    // remove the first and last items in the array, which are the focus traps
    elements.shift();
    elements.pop();
    return elements;
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      children = _this$props.children,
      isBottomActive = _this$props.isBottomActive,
      isTopActive = _this$props.isTopActive;
    return /*#__PURE__*/React.createElement("div", {
      className: "asc-focus-trap",
      ref: function ref(node) {
        _this2.container = node;
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "asc-acc-hidden",
      tabIndex: isTopActive ? '0' : '-1',
      onFocus: this.handleTopFocus
    }), children, /*#__PURE__*/React.createElement("span", {
      className: "asc-acc-hidden",
      tabIndex: isBottomActive ? '0' : '-1',
      onFocus: this.handleBottomFocus
    }));
  };
  _createClass(FocusTrap, [{
    key: "firstFocusableElement",
    get: function get() {
      var focusableElements = this.state.focusableElements;
      return focusableElements[0];
    }
  }, {
    key: "lastFocusableElement",
    get: function get() {
      var focusableElements = this.state.focusableElements;
      return focusableElements[focusableElements.length - 1];
    }
  }]);
  return FocusTrap;
}(Component);
FocusTrap.propTypes = {
  /**
   * Toggle the bottom focus trap on and off
   */
  isBottomActive: PropTypes.bool,
  /**
   * Toggle the top focus trap on and off
   */
  isTopActive: PropTypes.bool,
  /**
   * Content to display within the focus trap
   */
  children: PropTypes.node,
  /**
   * Callback function when the bottom focus trap is hit
   */
  onBottomFocus: PropTypes.func,
  /**
   * Callback function when the top focus trap is hit
   */
  onTopFocus: PropTypes.func
};
FocusTrap.defaultProps = {
  isBottomActive: true,
  isTopActive: true,
  onBottomFocus: function onBottomFocus() {},
  onTopFocus: function onTopFocus() {}
};
export default FocusTrap;